import { Outlet } from 'react-router-dom';
import { useSupportStandard } from './useSupportStandard';
import { Header } from 'ui/components/supporter/panes/Header/Header';
import { Sidebar } from 'ui/components/supporter/panes/Sidebar/Sidebar';
import styled from '@emotion/styled';
import { mqUser } from 'utils/responsive';

/**
 * サポーター系ログイン後ページの共通処理
 */
const Wrapper = styled.div<{ isSideOpen: boolean }>`
    display: flex;
    height: 100vh;
    @supports (height: 100svh) {
        height: 100svh;
    }
    margin: 0 auto;

    .header {
        height: var(--height-pc-header);

        ${mqUser('SP')} {
            height: var(--height-sp-header);
        }
    }

    .sidebar {
        width: var(--width-pc-side-menu);
        min-width: var(--width-pc-side-menu);
        height: 100vh;
        @supports (height: 100svh) {
            height: 100svh;
        }
        transform: ${(props) => (props.isSideOpen ? 'translateX(0)' : 'translateX(-200px)')};
        transition: transform 0.3s ease-out;

        ${mqUser('SP')} {
            width: 0;
            transform: none;
            min-width: initial;
        }
    }

    .sp-sidebar {
        display: none;

        ${mqUser('SP')} {
            display: block;
            z-index: var(--z-index-sidebar);
        }
    }

    .main {
        padding: 0;
        overflow-y: auto;
        max-width: calc(100svw - 200px);

        ${mqUser('SP')} {
            max-width: 100svw;
        }
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100svh;
`;

export const SupportStandard: React.FC = () => {
    const { mainRef, canEnter, isSideOpen } = useSupportStandard();

    return !canEnter ? null : (
        <Wrapper isSideOpen={isSideOpen}>
            <div className="sidebar">
                <Sidebar />
            </div>
            <div className="sp-sidebar">
                <Sidebar />
            </div>
            <Container>
                <div className="header">
                    <Header />
                </div>
                <div ref={mainRef} className="main">
                    <Outlet />
                </div>
            </Container>
        </Wrapper>
    );
};
